__webpack_require__.p = "/reports-components-library-feature-discrimination/referrals-hub/";